"use client";

import dynamic from "next/dynamic";

const MusicDemo = dynamic(() => import("./MusicDemo"));

export default MusicDemo;
